module.exports = __webpack_public_path__ + "img/avatar.921ede69.png";